<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Ticket Configuration</div>

  </div>
  <div class="modal-body font-13">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>

    <div class="form-group">
      <mat-radio-group (change)="onButtonChange($event)">
        <mat-radio-button *ngFor="let button of ttypes;" [value]="button.id"
                          [checked]="button.checked">{{button.name}}</mat-radio-button>&nbsp;
      </mat-radio-group>
    </div>
    <div class="form-group">
      <!--<mat-slide-toggle (toggleChange)="slideChange()" [checked]="slideChecked"> <b class="blue">Forward Workflow</b></mat-slide-toggle>-->
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="categorySelected"
              (change)="onCategoryChange($event.target.selectedIndex)">
        <option *ngFor="let category of categories" [value]="category.id">{{category.name}}</option>
      </select>
    </div>
    <div class="row">
      <div class="col">
        <!--<input type="text" class="form-control" placeholder="First name">-->
        <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="typeSelected1"
                (change)="onType1Change()">
          <option *ngFor="let prefix of prefixType" [value]="prefix.id">{{prefix.name}}</option>
        </select>
      </div>
      <div class="col">
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="prefix1" [readOnly]="isReadonly1" [maxlength]="prefixLength" placeholder="Enter Prefix">
      </div>
    </div>
    <div class="row">
      <div class="col">
        <!--<input type="text" class="form-control" placeholder="First name">-->
        <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="typeSelected2"
          (change)="onType2Change()">
          <option *ngFor="let prefix of prefixType" [value]="prefix.id">{{prefix.name}}</option>
        </select>
      </div>
      <div class="col">
        <input type="text" class="form-control radius-0 font-13"  [readOnly]="isReadonly2" [(ngModel)]="prefix2" [maxlength]="prefixLength" placeholder="Enter Prefix">
      </div>
    </div>
    <div class="row">
      <div class="col">
        <!--<input type="text" class="form-control" placeholder="First name">-->
        <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="typeSelected3"
          (change)="onType3Change()">
          <option *ngFor="let prefix of prefixType" [value]="prefix.id">{{prefix.name}}</option>
        </select>
      </div>
      <div class="col">
        <input type="text" class="form-control radius-0 font-13" [readOnly]="isReadonly3" [(ngModel)]="prefix3" [maxlength]="prefixLength" placeholder="Enter Prefix">
      </div>
    </div>
    <div class="form-group">
      <mat-checkbox [(ngModel)]="isIncrimental"><span class="mat-checkbox-layout"><b>Please select the check box if incremental ticket number is required(if
        not selected ticket number will reset first day of every year)</b></span></mat-checkbox>
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="startNumber"
      placeholder="Start Number">
    </div>
    <!--<div class="form-group">-->
      <!--<input type="text" class="form-control radius-0 font-13" [(ngModel)]="prefix"-->
             <!--placeholder="Enter Prefix">-->
    <!--</div>-->
    <!--<div class="form-group">-->
      <!--<input type="text" class="form-control radius-0 font-13" [(ngModel)]="catPrefix"-->
             <!--placeholder="Enter Category Prefix">-->
    <!--</div>-->
    <!--<div class="form-group">-->
    <!--<input type="text" class="form-control radius-0 font-13" [(ngModel)]="length"-->
    <!--placeholder="Ticket Length">-->
    <!--</div>-->
    <!--<div class="form-group">-->
      <!--<mat-radio-group (change)="onStartButtonChange($event)">-->
        <!--<mat-radio-button value="D" [checked]="true">Start With Date</mat-radio-button>&nbsp;-->
        <!--<mat-radio-button value="N">Start With Number</mat-radio-button>-->
      <!--</mat-radio-group>-->
    <!--</div>-->
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<notifier-container></notifier-container>
